<template>
  <li class="tree-node-list-item">
    <div class="tree-node-line" :class="nodeClass">
      <i class="arrow" :class="arrowClass" @click="onClick" />
      <el-checkbox v-if="showCheckboxes" v-model="node.checked" @change="checkboxChanged"></el-checkbox>
      <i :class="nodeIcon" class="icon"></i>
      <div v-html="node.text" @click="textClicked"></div>
    </div>
    <div v-if="clicked && node.children">
      <ul v-for="(element, index) in node.children" :key="index">
        <tree-node :node="element"></tree-node>
      </ul>
    </div>
  </li>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      clicked: false,
      nodeClass: "",
      nodeIcon: "",
      arrowClass: "",
    };
  },
  name: "tree-node",
  props: ["node"],
  methods: {
    onClick() {
      this.clicked = !this.clicked;
      if (this.arrowClass === "el-icon-caret-right") {
        this.arrowClass = "el-icon-caret-bottom";
      } else if (this.arrowClass === "el-icon-caret-bottom")
        this.arrowClass = "el-icon-caret-right";
    },
    textClicked() {
      if (this.showCheckboxes) {
        this.node.checked = !this.node.checked;
        this.checkboxChanged();
      } else this.onClick();
    },
    checkboxChanged() {
      if (
        this.node.children &&
        this.node.children.length > 0
      ) {
        for (let child of this.node.children) {
          if (this.node.checked) child.checked = true;
          else child.checked = false;
        }
      }
    },
  },
  created() {
    if (this.node.children && this.node.children.length > 0) {
      this.nodeClass = "node";
      this.arrowClass = "el-icon-caret-right";
    } else this.nodeClass = "leaf";

    if (!this.showCheckboxes) {
      if (
        this.node.type === "app param list" ||
        this.node.type === "app param"
      ) {
        this.nodeIcon = "el-icon-check";
      } else if (
        this.node.type === "server param list" ||
        this.node.type === "server param" ||
        this.node.type === "task param"
      ) {
        this.nodeIcon = "el-icon-check";
      } else if (this.node.type === "app list" || this.node.type === "app") {
        this.nodeIcon = "el-icon-s-tools";
      } else if (this.node.type === "server") {
        this.nodeIcon = "el-icon-files";
      } else if (this.node.type === "task list" || this.node.type === "task") {
        this.nodeIcon = "el-icon-finished";
      } else if (this.node.type === "db" || this.node.type === "db list") {
        this.nodeIcon = "el-icon-coin";
      }
    }
  },
  computed: {
    ...mapGetters(["showCheckboxes"]),
  },
};
</script>

<style scoped>
.node {
  font-weight: 600;
  cursor: pointer;
}
.leaf {
  cursor: pointer;
  margin-left: 16px;
}
.main-list ul {
  padding-left: 30px;
  margin: 6px 0;
}
ul {
  list-style: none;
}
.tree-node-line {
  display: flex;
  padding: 0;
  padding-left: 3px;
  margin-top: 5px;
}
.tree-node-line:hover{
  color: var(--active-color);
}
.icon {
  margin-right: 5px;
  margin-top: 3px;
}
.arrow {
  transform: scale(1.1);
  margin-top: 1.5px;
}
.el-checkbox {
  margin: 1.5px 3px 0px 3px;
  transform: scale(1.1);
}
</style>
